import { useEditorContext } from "../EditorContext";
import {
  getBorderStyleObj,
  getFormLableStyleObj,
} from "../FormText/FormBaseStyle";
import { toRGBA } from "../parser/utils";


function mergeLabelStyle(base, custom) {
  const merged = { ...base };
  for (const key in custom) {
    const value = custom[key];
    // This is the crucial condition:
    if (value !== undefined && value !== null && value !== '') {
      merged[key] = value;
    }
  }
  return merged;
}
export default ({ data }) => {
  const {
    label,
    required,
    lowRatingLabel,
    highRatingLabel,
    paddingTop,
    paddingBottom,
    paddingRight,
    paddingLeft,
    ratingLevel = 5,
    hideLabel,
    ratingStyle,
    labelFontColor,
    labelDefaultFont,
    labelFontSize,
    labelHorizonAlignment,
  } = data;

  const { state } = useEditorContext();

  const { formTextColor, formBorderWidth, formBorderStyle, formBorderColor } =
    state.root.data;
  const customLabelStyle = {
    color: toRGBA(labelFontColor || formTextColor),
    fontFamily: labelDefaultFont,
    fontSize: labelFontSize,
    justifyContent: labelHorizonAlignment || "start",
  };


  const borderStyleObj = getBorderStyleObj(state.root.data);
  const lableStyle = getFormLableStyleObj(state.root.data);
  const style = mergeLabelStyle({ display: "flex", ...lableStyle }, customLabelStyle || {});
  return (
    <div
      style={{
        paddingTop,
        paddingBottom,
        paddingRight,
        paddingLeft,
        textAlign: "left",
      }}
    >
      <label style={{ ...style, display: hideLabel ? "none" : "flex" }}>
        {required && (
          <span style={{ color: "#ff4d4f", marginRight: 4 }}>*</span>
        )}
        {label}
      </label>
      <div style={{ ...borderStyleObj, padding: 5 }}>
        <div
          style={{
            display: hideLabel ? "none" : "flex",
            justifyContent: "space-between",
            borderBottom: [
              formBorderWidth + "px",
              formBorderStyle,
              toRGBA(formBorderColor),
            ].join(" "),
          }}
        >
          <div style={style}>{lowRatingLabel}</div>
          <div style={style}>{highRatingLabel}</div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            paddingTop: 5,
          }}
        >
          {Array(ratingLevel)
            .fill(null)
            .map((_, index) => {
              if (ratingStyle === "number") {
                return (
                  <div style={{ textAlign: "center" }}>
                    <div
                      style={{
                        width: 16,
                        height: 16,
                        borderRadius: "50%",
                        border: "1px solid #cccccc",
                      }}
                    />

                    <label style={{ color: toRGBA(formTextColor) }}>
                      {index + 1}
                    </label>
                  </div>
                );
              }

              return (
                <div key={index} style={{ fontSize: 16, color: "orange" }}>
                  ★
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};
